import React from 'react';

export function Tabs({ items, value, onChange }) {
  return (
    <div style={{ display: 'flex', gap: '4px', borderBottom: '1px solid var(--border)' }}>
      {items.map((item) => {
        const active = item.value === value;
        return (
          <button
            key={item.value}
            onClick={() => onChange && onChange(item.value)}
            style={{
              appearance: 'none', background: 'none', border: 'none', cursor: 'pointer',
              padding: '10px 4px', marginRight: '24px', fontFamily: 'var(--font-body)',
              fontSize: 'var(--fs-body-md)', fontWeight: active ? 600 : 400,
              color: active ? 'var(--brand-primary-ink)' : 'var(--text-muted)',
              borderBottom: active ? '2px solid var(--brand-primary)' : '2px solid transparent',
              marginBottom: '-1px', transition: 'color var(--duration-fast)',
            }}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
